export default __webpack_public_path__ + "static/FFF1-65fff754b76af0dc0c785ae8884cdb55.pdf";